const SHARE_PATTERN = /^\/(?:assistant\/)?s\/([^/]+)\/?$/;

export function isShareRoute(locationLike: Pick<Location, 'pathname'>): boolean {
  return SHARE_PATTERN.test(locationLike.pathname);
}

export function shareToken(locationLike: Pick<Location, 'pathname'>): string | null {
  const match = locationLike.pathname.match(SHARE_PATTERN);
  return match ? decodeURIComponent(match[1]) : null;
}

export function sharePath(token: string): string {
  // Matches settingsPath()'s convention: the app is deployed with /assistant/
  // as its stable SPA base, so a deep link works on every product hostname.
  return `/assistant/s/${encodeURIComponent(token)}`;
}
